import {
    Button,
    Col,
    Form,
    Modal,
    Input,
    Row,
    Table,
    Select,
    message,
    Radio,
    Space,
    DatePicker,
} from 'antd'
import React, { useState, useEffect } from 'react'
import qs from 'qs'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import {
    getPosts,
    createPost,
    updatePost,
    deletePost,
    batchUpdatePostsStatus,
} from '../../_services/service'
import { SearchForm } from './search-form'
import { PostForm } from './post-form'
import { BatchUpdatePostsStatusForm } from './batch-update-posts-status-form'

const getRandomuserParams = params => ({
    results: params.pagination?.pageSize,
    page: params.pagination?.current,
    ...params,
})
function antdPaginationAdapter(apiPagination) {
    return {
        current: apiPagination.page,
        total: apiPagination.total,
        pageSize: apiPagination.pageSize,
        showTotal: () => {
            return `每页${apiPagination.pageSize}条数据，共${apiPagination.total}条`
        },
    }
}

function validIntOrUndefined(value) {
    const num = Number.parseInt(value, 10)
    return !Number.isNaN(num) ? num : undefined
}
function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max)
}
function handleDelete(record, onSuccess) {
    Modal.confirm({
        title: 'Delete Post',
        content: <p>Are you sure to delete {record.title} ?</p>,
        onOk: async () => {
            try {
                await deletePost(record.id)
                message.success('Sucessfully deleted')
                onSuccess()
            } catch (e) {
                message.error('Delete unsuccessful')
            }
        },
    })
}

export default function App() {
    const [form] = Form.useForm()

    const [isEditing, setIsEditing] = useState(false)
    const [editingStudent, setEditingStudent] = useState(null)
    // const [data, setData] = useState()
    // const [loading, setLoading] = useState(false)
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    })

    function getDefaultQuery() {
        // 先不考虑服务端渲染
        const urlSearchParams = qs.parse(window.location.search, {
            ignoreQueryPrefix: true,
        })
        const { page, pageSize, title, status, order } = urlSearchParams
        const dto = {}
        if (typeof page === 'string') {
            dto.page = validIntOrUndefined(page) || 1
        }
        if (typeof pageSize === 'string') {
            dto.pageSize = validIntOrUndefined(pageSize) || 20
        }
        if (typeof title === 'string') {
            dto.title = title
        }
        if (typeof status === 'string') {
            dto.status = validIntOrUndefined(status)
        }
        if (typeof order === 'string') {
            const orderNum = validIntOrUndefined(order)
            dto.order = orderNum ? clamp(orderNum, 0, 1) : undefined
        }
        return dto
    }

    const [defaultQuery] = useState(getDefaultQuery)

    const [query, setQuery] = useState(defaultQuery)

    const [data, setData] = useState({
        list: [],
        pagination: {
            page: 1,
            pageSize: 20,
            total: 0,
        },
    })

    const [loading, setLoading] = useState(false)

    const [selectedRows, setSelectedRows] = useState([])

    const [selectedRecord, setSelectedRecord] = useState()

    const [modalActionType, setModalActionType] = useState('')
    const [modalActionLoading, setModalActionLoading] = useState(false)

    useEffect(() => {
        let isCurrent = true
        setLoading(true)
        getPosts(query)
            .then(res => isCurrent && setData(res))
            .finally(() => isCurrent && setLoading(false))
        return () => {
            // 防止组件已经卸载的时候, 还会对已经卸载的组件setState
            isCurrent = false
        }
        // query每次变化的时候都会重新调用接口
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    // const columns = [
    //     {
    //         title: 'Name',
    //         dataIndex: 'name',
    //         sorter: true,
    //         render: name => `${name.first} ${name.last}`,
    //         width: '20%',
    //     },
    //     {
    //         title: 'Gender',
    //         dataIndex: 'gender',
    //         filters: [
    //             {
    //                 text: 'Male',
    //                 value: 'male',
    //             },
    //             {
    //                 text: 'Female',
    //                 value: 'female',
    //             },
    //         ],
    //         width: '20%',
    //     },
    //     {
    //         title: 'Email',
    //         dataIndex: 'email',
    //     },
    //     {
    //         title: 'Actions',
    //         render: record => {
    //             return (
    //                 <>
    //                     <EditOutlined
    //                         onClick={() => {
    //                             onEditStudent(record)
    //                         }}
    //                     />
    //                     <DeleteOutlined
    //                         onClick={() => {
    //                             onDeleteStudent(record)
    //                         }}
    //                         style={{ color: 'red', marginLeft: 12 }}
    //                     />
    //                 </>
    //             )
    //         },
    //     },
    // ]
    const clean = () => {
        setSelectedRecord(undefined)
        setSelectedRows([])
    }
    const handleModalCancel = () => {
        setModalActionType('')
        clean()
    }
    const modalActionFactory = options => {
        const {
            api,
            successMessage = 'success',
            errorMessage = 'unsuccess',
        } = options
        return async (...args) => {
            setModalActionLoading(true)
            try {
                await api(...args)
                message.success(successMessage)
                // 刷新列表
                setQuery(prev => Object.assign({}, prev))
                handleModalCancel()
            } catch (e) {
                message.error(errorMessage)
            } finally {
                setModalActionLoading(false)
            }
        }
    }
    const columns = [
        { dataIndex: 'id', title: 'id' },
        { dataIndex: 'title', title: 'title' },
        { dataIndex: 'content', title: 'content' },
        {
            dataIndex: 'status',
            title: 'status',
            filters: [
                { text: '0', value: 0 },
                { text: '1', value: 1 },
            ],
            filterMultiple: false,
            filteredValue:
                query.status === undefined
                    ? undefined
                    : [query.status.toString()],
        },
        {
            dataIndex: 'order',
            title: 'order',
            sorter: true,
            sortOrder:
                query.order === undefined
                    ? undefined
                    : { 0: 'ascend', 1: 'descend' }[query.order],
        },
        { dataIndex: 'createdAt', title: 'createdAt', sorter: true },
        { dataIndex: 'updatedAt', title: 'updatedAt' },
        {
            title: 'Actions',
            render: (_, record) => (
                <Space>
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setSelectedRecord(record)
                            setModalActionType('update')
                        }}
                    >
                        Edit
                    </span>
                    <span
                        style={{ color: 'red', cursor: 'pointer' }}
                        onClick={() =>
                            handleDelete(record, () =>
                                setQuery(prev => {
                                    const prevPage = prev.page || 1
                                    return Object.assign(
                                        Object.assign({}, prev),
                                        {
                                            page:
                                                data.list.length === 1
                                                    ? clamp(
                                                          prevPage - 1,
                                                          1,
                                                          prevPage
                                                      )
                                                    : prevPage,
                                        }
                                    )
                                })
                            )
                        }
                    >
                        Delete
                    </span>
                </Space>
            ),
        },
    ]

    // const fetchData = () => {
    //     setLoading(true)
    //     fetch(
    //         `https://randomuser.me/api?${qs.stringify(
    //             getRandomuserParams(tableParams)
    //         )}`
    //     )
    //         .then(res => res.json())
    //         .then(({ results }) => {
    //             setData(results)
    //             setLoading(false)
    //             setTableParams({
    //                 ...tableParams,
    //                 pagination: {
    //                     ...tableParams.pagination,
    //                     total: 200,
    //                 },
    //             })
    //         })
    // }

    // useEffect(() => {
    //     fetchData()
    // }, [JSON.stringify(tableParams)])

    const onAddStudent = () => {
        const randomNumber = parseInt(Math.random() * 1000)
        const newStudent = {
            id: randomNumber,
            name: 'Name ' + randomNumber,
            email: randomNumber + '@gmail.com',
            address: 'Address ' + randomNumber,
        }
        setData(pre => {
            return [...pre, newStudent]
        })
    }
    const onDeleteStudent = record => {
        Modal.confirm({
            title: 'Are you sure, you want to delete this student record?',
            okText: 'Yes',
            okType: 'danger',
            onOk: () => {
                setData(pre => {
                    return pre.filter(student => student.id !== record.id)
                })
            },
        })
    }
    const onEditStudent = record => {
        setIsEditing(true)
        setEditingStudent({ ...record })
    }
    const resetEditing = () => {
        setIsEditing(false)
        setEditingStudent(null)
    }

    const onFinish = values => {
        message.success('Submit success!')
    }

    const onFinishFailed = () => {
        message.error('Submit failed!')
    }

    const onFill = () => {
        form.setFieldsValue({
            url: 'https://taobao.com/',
        })
    }

    const periodEndingChange = value => {
        console.log(`selected ${value}`)
    }

    const onPeriodDateChange = (date, dateString) => {
        console.log(date, dateString)
    }

    return (
        <div className="App">
            <header className="App-header">
                <SearchForm
                    defaultQuery={defaultQuery}
                    onSubmit={values =>
                        setQuery(prev =>
                            Object.assign(
                                Object.assign(Object.assign({}, prev), values),
                                { page: 1 }
                            )
                        )
                    }
                    onReset={values =>
                        setQuery(prev =>
                            Object.assign(
                                Object.assign(Object.assign({}, prev), values),
                                { page: 1 }
                            )
                        )
                    }
                />
                <div style={{ margin: '15px 0' }}>
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => setModalActionType('create')}
                        >
                            Create
                        </Button>

                        <Button
                            type="primary"
                            disabled={selectedRows.length <= 0}
                            onClick={() => {
                                setModalActionType('batchUpdateStatus')
                            }}
                        >
                            Batch Approval
                        </Button>
                    </Space>
                </div>
                {/* <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Row gutter={{ md: 24 }}>
                        <Col xs={8} sm={16} md={6} lg={6}>
                            <div className="m-1 p-1">
                                <Form.Item
                                    name="period"
                                    label="Timesheets period"
                                >
                                    <Select
                                        defaultValue="week"
                                        onChange={periodEndingChange}
                                        options={[
                                            {
                                                value: 'week',
                                                label: 'Week',
                                            },
                                            {
                                                value: 'fortnight',
                                                label: 'Fortnight',
                                            },
                                            {
                                                value: 'month',
                                                label: 'Month',
                                            },
                                        ]}
                                    />
                                </Form.Item>
                            </div>
                        </Col>
                        <Col xs={8} sm={16} md={6} lg={6}>
                            <div className="m-1 p-1">
                                <Form.Item name="date" label="date">
                                    <DatePicker onChange={onPeriodDateChange} />
                                </Form.Item>
                            </div>
                        </Col>
                        <Col xs={12} sm={16} md={12} lg={12}>
                            <div className="m-1 p-1">
                                <Form.Item name="employee" label="Employee">
                                    <Select
                                        defaultValue="week"
                                        onChange={periodEndingChange}
                                        options={[
                                            {
                                                value: 'week',
                                                label: 'Week',
                                            },
                                            {
                                                value: 'fortnight',
                                                label: 'Fortnight',
                                            },
                                            {
                                                value: 'month',
                                                label: 'Month',
                                            },
                                        ]}
                                    />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Space>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                            <Button htmlType="button" onClick={onFill}>
                                Fill
                            </Button>
                        </Space>
                    </Form.Item>
                </Form> */}
                {/* <Button onClick={onAddStudent}>Add a new Student</Button> */}
                {/* <Table
                    columns={columns}
                    dataSource={data}
                    rowKey={record => record.login.uuid}
                ></Table> */}
                <Table
                    rowKey="id"
                    dataSource={data.list}
                    columns={columns}
                    loading={loading}
                    pagination={Object.assign(
                        {},
                        antdPaginationAdapter(data.pagination)
                    )}
                    onChange={(pagination, filters, sorter) => {
                        setQuery(prev =>
                            Object.assign(Object.assign({}, prev), {
                                page: pagination.current || 1,
                                pageSize: pagination.pageSize || 20,
                                status:
                                    filters.status && filters.status.length > 0
                                        ? Number(filters.status[0])
                                        : undefined,
                                order:
                                    !Array.isArray(sorter) &&
                                    !!sorter.order &&
                                    sorter.field === 'order'
                                        ? { ascend: 0, descend: 1 }[
                                              sorter.order
                                          ]
                                        : undefined,
                            })
                        )
                    }}
                    rowSelection={{
                        selectedRowKeys: selectedRows.map(item => item.id),
                        onChange: (_, rows) => setSelectedRows(rows),
                    }}
                ></Table>
                <PostForm
                    title="Create Post"
                    visible={modalActionType === 'create'}
                    onCreate={modalActionFactory({
                        api: createPost,
                        successMessage: '创建成功',
                        errorMessage: '创建失败',
                    })}
                    onCancel={handleModalCancel}
                    loading={modalActionLoading}
                />
                <PostForm
                    title="Update Post"
                    record={selectedRecord}
                    visible={modalActionType === 'update'}
                    onUpdate={modalActionFactory({
                        api: updatePost,
                        successMessage: 'Edit finished',
                        errorMessage: 'Edit unsuccessful',
                    })}
                    onCancel={handleModalCancel}
                    loading={modalActionLoading}
                />
                <BatchUpdatePostsStatusForm
                    visible={modalActionType === 'batchUpdateStatus'}
                    records={selectedRows}
                    loading={modalActionLoading}
                    onCancel={handleModalCancel}
                    onSubmit={modalActionFactory({
                        api: batchUpdatePostsStatus,
                        successMessage: 'Bulk Edit finished',
                        errorMessage: 'Bulk Edit unsuccessful',
                    })}
                />

                <Modal
                    title="Edit Student"
                    open={isEditing}
                    okText="Save"
                    onCancel={() => {
                        resetEditing()
                    }}
                    onOk={() => {
                        setData(pre => {
                            return pre.map(student => {
                                if (student.id === editingStudent.id) {
                                    return editingStudent
                                } else {
                                    return student
                                }
                            })
                        })
                        resetEditing()
                    }}
                >
                    <Space direction="vertical">
                        <Input
                            value={editingStudent?.name}
                            onChange={e => {
                                setEditingStudent(pre => {
                                    return { ...pre, name: e.target.value }
                                })
                            }}
                        />
                        <Input
                            value={editingStudent?.email}
                            onChange={e => {
                                setEditingStudent(pre => {
                                    return { ...pre, email: e.target.value }
                                })
                            }}
                        />
                        <Input
                            value={editingStudent?.address}
                            onChange={e => {
                                setEditingStudent(pre => {
                                    return { ...pre, address: e.target.value }
                                })
                            }}
                        />
                    </Space>
                </Modal>
            </header>
        </div>
    )
}

// import React from 'react';
// import { useMount, useBoolean, useAntdTable } from 'ahooks';
// import { Button, Col, Form, Input, Row, Table, Select, message  } from 'antd';
// import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
// const { Option } = Select;
// const getTableData = ({ current, pageSize }, formData) => {
//     let query = `page=${current}&size=${pageSize}`;
//     Object.entries(formData).forEach(([key, value]) => {
//         if (value) {
//             query += `&${key}=${value}`;
//         }
//     });
//     return fetch(`https://randomuser.me/api?results=55&${query}`)
//         .then((res) => res.json())
//         .then((res) => ({
//         total: res.info.results,
//         list: res.results,
//     }));
// };
// export default () => {
//   useMount(() => {
//     message.info('mount');

//   });

//   const onDeleteStudent = (record) => {

//     var data = tableProps.dataSource

//     tableProps.dataSource = {
//       total: 0,
//       list: [],
//   }
//     console.log(record)

//   };
//   const onEditStudent = (record) => {
//     console.log(record)
//   };

//   const refreshTable = () => {
//     getTableData({ current: 1, pageSize: 5}, {})
//   }
//     const [form] = Form.useForm();
//     const { tableProps, search } = useAntdTable(getTableData, {
//         defaultPageSize: 5,
//         form,
//     });
//     const { type, changeType, submit, reset } = search;
//     const columns = [
//         {
//             title: 'name',
//             dataIndex: ['name', 'last'],
//         },
//         {
//             title: 'email',
//             dataIndex: 'email',
//         },
//         {
//             title: 'phone',
//             dataIndex: 'phone',
//             sorter: (a, b) => a.phone - b.phone,
//         },
//         {
//             title: 'gender',
//             dataIndex: 'gender',
//         },
//         {
//           dataIndex: "Actions",
//           title: "Actions",
//           render: (_, record) => {
//             return (
//               <>
//                 <EditOutlined
//                   onClick={() => {
//                     onEditStudent(record);
//                   }}
//                 />
//                 <DeleteOutlined
//                   onClick={() => {
//                     onDeleteStudent(record);
//                   }}
//                   style={{ color: "red", marginLeft: 12 }}
//                 />
//               </>
//             );
//           }
//         }
//     ];
//     const advanceSearchForm = (<div>
//       <Form form={form}>
//         <Row gutter={24}>
//           <Col span={8}>
//             <Form.Item label="name" name="name">
//               <Input placeholder="name"/>
//             </Form.Item>
//           </Col>
//           <Col span={8}>
//             <Form.Item label="email" name="email">
//               <Input placeholder="email"/>
//             </Form.Item>
//           </Col>
//           <Col span={8}>
//             <Form.Item label="phone" name="phone">
//               <Input placeholder="phone"/>
//             </Form.Item>
//           </Col>
//         </Row>
//         <Row>
//           <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
//             <Button type="primary" onClick={submit}>
//               Search
//             </Button>
//             <Button onClick={reset} style={{ marginLeft: 16 }}>
//               Reset
//             </Button>
//             <Button type="link" onClick={changeType}>
//               Simple Search
//             </Button>
//           </Form.Item>
//         </Row>
//       </Form>
//     </div>);
//     const searchForm = (<div style={{ marginBottom: 16 }}>
//       <Form form={form} style={{ display: 'flex', justifyContent: 'flex-end' }}>
//         <Form.Item name="gender">
//           <Select style={{ width: 120, marginRight: 16 }} onChange={submit}>
//             <Option value="">all</Option>
//             <Option value="male">male</Option>
//             <Option value="female">female</Option>
//           </Select>
//         </Form.Item>
//         <Form.Item name="name">
//           <Input.Search placeholder="enter name" style={{ width: 240 }} onSearch={submit}/>
//         </Form.Item>
//         <Button type="link" onClick={changeType}>
//           Advanced Search
//         </Button>
//         <Button type="link" onClick={refreshTable}>
//           Refresh
//         </Button>
//       </Form>
//     </div>);
//     return (<div>
//       {type === 'simple' ? searchForm : advanceSearchForm}
//       <Table columns={columns} rowKey="email" {...tableProps}/>
//     </div>);
// };

// import React from 'react'
// import { useForm } from "react-hook-form";

// export default function App() {
//   const { register, handleSubmit, watch, formState: { errors } } = useForm();
//   const onSubmit = data => {
//     console.log(data);
//   }

//   console.log(watch("example")); // watch input value by passing the name of it

//   return (
//     <form onSubmit={handleSubmit(onSubmit)}>
//       <input defaultValue="test" {...register("example")} />

//       <input {...register("exampleRequired", { required: true })} />
//       {errors.exampleRequired && <span>This field is required</span>}

//       <input type="submit" />
//     </form>
//   );
// }

// import PropTypes from 'prop-types'
// import React, { Component } from 'react'
// import { Col, Row } from 'antd'
// import { useForm } from "react-hook-form";

// export default class ManagerApproval extends Component {

//     const { register, handleSubmit, watch, formState: { errors } } = useForm();

//     onSubmit= (data) => {
//         console.log(data)
//     }

//     render() {
//         return (
//             <div>
//                 <Row gutter={[24, 24]}>
//                     <Col span={6}>col1</Col>
//                     <Col span={6}>col2</Col>
//                     <Col span={6}>col3</Col>
//                     <Col span={6}>col4</Col>
//                 </Row>
//                 <Row>
//                     <Col span={12}>col-12</Col>
//                     <Col span={12}>col-12</Col>
//                 </Row>
//                 <Row>
//                     <Col span={8}>col-8</Col>
//                     <Col span={8}>col-8</Col>
//                     <Col span={8}>col-8</Col>
//                 </Row>
//                 <Row>
//                     <Col span={6}>col-6</Col>
//                     <Col span={6}>col-6</Col>
//                     <Col span={6}>col-6</Col>
//                     <Col span={6}>col-6</Col>
//                 </Row>
//                  <form onSubmit={handleSubmit(onSubmit)}>
//                     {/* register your input into the hook by invoking the "register" function */}
//                     <input defaultValue="test" {...register("example")} />

//                     {/* include validation with required or other standard HTML validation rules */}
//                     <input {...register("exampleRequired", { required: true })} />
//                     {/* errors will return when field validation fails  */}
//                     {errors.exampleRequired && <span>This field is required</span>}

//                     <input type="submit" />
//                     </form>
//             </div>
//         )
//     }
// }
